module.exports = __webpack_public_path__ + "img/prioritas_interpackmaxi_cod_dg_k.d6665e7e.png";